export default __webpack_public_path__ + "static/media/im-wald-im-schoene-grueene-wald.4617473e.webp";